import { contains } from 'jquery';

export default function setAttributesSelect() {
  let selectFields = document.querySelectorAll('[data-product-box] .is-select .attr-selected');

  let attributes = document.querySelectorAll('[data-product-box] .is-select .inner .label');

  selectFields.forEach((field) => {
    field.addEventListener('click', () => {
      let select = field.closest('.prod-option ').querySelector('.inner');

      if (select.classList.contains('-open')) {
        field.classList.remove('-open');
        select.classList.remove('-open');
      } else {
        field.classList.add('-open');
        select.classList.add('-open');
      }
    });
  });

  attributes.forEach((attribute) => {
    let select = attribute.closest('.prod-option ').querySelector('.inner');
    let selectFieldText = attribute.closest('.prod-option ').querySelector('.attr-selected .text');
    // let selectFieldColor = attribute.closest('.prod-option ').querySelector('.attr-selected .color');

    attribute.addEventListener('click', () => {
      let attributeValue = attribute.getAttribute('data-text');

      //ADICIONA A COR AO SELECT
      if (attributeValue.includes('|')) {
        let textValue = attributeValue.split('|')[0].trim();
        // let colorValue = attributeValue.split('|')[1].trim();

        // if (colorValue.includes('#fff')) {
        //   selectFieldColor.classList.add('-is-white');
        // } else {
        //   selectFieldColor.classList.remove('-is-white');
        // }

        selectFieldText.innerHTML = textValue;
        // selectFieldColor.style.backgroundColor = colorValue;
        // selectFieldColor.style.display = 'block';
      } else {
        if (attributeValue.includes('(')) {
          let highlightText = attributeValue.split('(')[0].trim();
          selectFieldText.innerHTML = highlightText;
        } else {
          selectFieldText.innerHTML = attributeValue;
        }
      }

      select.classList.remove('-open');
    });
  });
}
